import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  useEffect(() => {
    const rotateVideos = () => {
      const embeds = document.querySelectorAll(
        '#video-rotator .embed-responsive'
      );
      if (!embeds.length) return;

      const pick = Math.floor(Math.random() * embeds.length);
      embeds.forEach((el, i) => {
        el.style.display = i === pick ? '' : 'none';
      });
    };

    rotateVideos();
  }, []);

  const currentYear = new Date().getFullYear();

  const links = [
    { label: 'Policy', href: '/policy' },
    { label: 'Prayer Request', href: '/prayer' },
    { label: 'Salvation', href: '#salvation' },
    { label: 'Accepting Christ', href: '#salvation' },
    { label: 'Becoming a Member', href: '/members' },
  ];

  return (
    <div>
      {/* Main Footer Content */}
      <div className="g-bg-black-opacity-0_9 g-color-white-opacity-0_8 g-pt-50 g-pb-25">
        <div className="container">
          <div className="row">
            {/* Logo & Description */}
            <div className="col-lg-3 col-md-6 col-sm-6 col-12 g-mb-25 g-mb-0--lg">
              <a className="d-block g-mb-25" href="/">
                <img
                  src="/images/bishopLogo.jpg"
                  className="img-fluid"
                  alt="Bishop K.J. Brown Ministries"
                />
              </a>
              <p>
                Bishop K.J. Brown Ministries is dedicated to{' '}
                <em>&quot;Building Winning Lives&quot;</em> through practical,
                scripture-based teaching and preaching.
              </p>
            </div>

            {/* Useful Links */}
            <div className="col-lg-3 col-md-6 col-sm-6 col-12 g-mb-25 g-mb-0--lg">
              <div className="u-heading-v3-1 g-brd-white-opacity-0_3 g-mb-25">
                <h2 className="u-heading-v3__title h6 text-uppercase g-brd-white">
                  Useful Links
                </h2>
              </div>
              <nav>
                <ul className="list-unstyled g-mt-minus-10 mb-0">
                  {links.map((link, i) => {
                    const isInternalRoute = link.href.startsWith('/');

                    return (
                      <li
                        key={i}
                        className="g-pos-rel g-brd-bottom g-brd-white-opacity-0_1 g-py-10"
                      >
                        <h4 className="h6 g-pr-20 mb-0">
                          {isInternalRoute ? (
                            <Link
                              className="g-color-white-opacity-0_8 g-color-white--hover"
                              to={link.href}
                            >
                              {link.label}
                            </Link>
                          ) : (
                            <a
                              className="g-color-white-opacity-0_8 g-color-white--hover"
                              href={link.href}
                            >
                              {link.label}
                            </a>
                          )}
                          <i className="fa fa-angle-right g-absolute-centered--y g-right-0" />
                        </h4>
                      </li>
                    );
                  })}
                </ul>
              </nav>
            </div>

            {/* Contact Info */}
            <div className="col-lg-3 col-md-6 col-sm-6 col-12 g-mb-25 g-mb-0--lg">
              <div className="u-heading-v3-1 g-brd-white-opacity-0_3 g-mb-25">
                <h2 className="u-heading-v3__title h6 text-uppercase g-brd-white">
                  Our Contacts
                </h2>
              </div>
              <address className="g-font-size-12 mb-0">
                <div className="d-flex g-mb-25">
                  <span className="u-icon-v3 u-icon-size--xs g-bg-white-opacity-0_1 g-color-white-opacity-0_6 g-mr-10">
                    <i className="fa fa-map-marker" />
                  </span>
                  <p className="mb-0">
                    9476 Highway 6 South
                    <br />
                    Suite 313
                    <br />
                    Houston, TX 77083
                  </p>
                </div>
                <div className="d-flex g-mb-25">
                  <span className="u-icon-v3 u-icon-size--xs g-bg-white-opacity-0_1 g-color-white-opacity-0_6 g-mr-10">
                    <i className="fa fa-phone" />
                  </span>
                  <p className="mb-0">+1 (832) 246-5377</p>
                </div>
                <div className="d-flex">
                  <span className="u-icon-v3 u-icon-size--xs g-bg-white-opacity-0_1 g-color-white-opacity-0_6 g-mr-10">
                    <i className="fa fa-globe" />
                  </span>
                  <p className="mb-0">
                    <a
                      href="mailto:bishopkjbrown@gmail.com"
                      className="g-color-white-opacity-0_8 g-color-white--hover"
                    >
                      bishopkjbrown@gmail.com
                    </a>
                    <br />
                    <a
                      href="https://www.bishopkjbrown.org"
                      className="g-color-white-opacity-0_8 g-color-white--hover"
                    >
                      www.bishopkjbrown.org
                    </a>
                  </p>
                </div>
              </address>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom Bar */}
      <footer className="g-bg-gray-dark-v1 g-color-white-opacity-0_8 g-py-20">
        <div className="container">
          <div className="row">
            <div className="col-md-8 text-center text-md-left g-mb-15 g-mb-0--md">
              <div className="d-lg-flex">
                <small className="d-block g-font-size-default g-mr-10 g-mb-10 g-mb-0--md">
                  &copy; {currentYear} – All Rights Reserved
                </small>
              </div>
            </div>
            <div className="col-md-4 align-self-center">
              <ul className="list-inline text-center text-md-right mb-0">
                {/* social icons unchanged */}
              </ul>
            </div>
          </div>
        </div>
      </footer>

      {/* Scroll to Top */}
      <a
        className="js-go-to u-go-to-v1"
        href="#"
        data-type="fixed"
        data-position='{"bottom": 15, "right": 15}'
        data-offset-top="400"
        data-compensation="#js-header"
        data-show-effect="zoomIn"
      >
        <i className="hs-icon hs-icon-arrow-top" />
      </a>
    </div>
  );
};

export default Footer;
